
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"7","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.633 3.336L3.477.43h.539l2.843 2.914-.46.492-2.094-1.664v9.773l2.101-1.687.461.492-2.851 2.938h-.54L.626 10.78l.46-.523 2.103 1.687V2.18L1.094 3.828l-.461-.492z","fill":"currentColor"}})])
          )
        }
      }
    